var TagalysCustomisations = {};

TagalysCustomisations.setTagalysConfiguration = function () {
  var configuration = {
    api: {
      serverUrl: "https://api-r4.tagalys.com",
    },
    locale: "en-GB",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: "GBP",
      label: "£",
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function () {
      return true;
    },
    track: true,
  };
  Tagalys.setConfiguration(configuration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var platformConfiguration = {
    platform: "Shopify",
    countryCode: "GB",
    baseCountryCode: "GB",
    storefrontAPI: {
      accessToken: "cd6fc9b5c266f53faf13e76f964a155a",
      myShopifyDomain: "au-vodka.myshopify.com",
    },
    metafields: {
      products: [],
    },
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initSmartWidget = function () {
  var cfg = window.__AU_TAGALYS_CONFIG__ || {};
  Tagalys.UIWidgets.Recommendations.init("[data-smart-widget]", {
    recommendationId: cfg.recommendationId || "8c8e0099774de8885ab6"
  });
};

TagalysCustomisations.getProductIdsForRecommendations = function (cartData) {
  var cfg = window.__AU_TAGALYS_CONFIG__ || {};
  var settingRaw = cfg.productIds || "9336888164660";
  var settingIds = String(settingRaw)
    .split(',')
    .map(function (id) { return id.trim(); })
    .filter(function (id) { return id.length > 0; });

  function takeLastMaxThree(arr) {
    if (!arr || arr.length === 0) return [];
    if (arr.length <= 3) return arr.slice();
    return arr.slice(arr.length - 3);
  }

  // 1. Gather product IDs from cart data object if passed or globally present
  var rawCartProductIds = [];
  var cartObj = cartData || window.__AU_CART_DATA__;
  if (cartObj && Array.isArray(cartObj.items) && cartObj.items.length > 0) {
    for (var i = 0; i < cartObj.items.length; i++) {
      var item = cartObj.items[i];
      var pid = item.product_id || item.productId;
      if (pid) {
        var pidStr = String(pid).trim();
        if (pidStr) rawCartProductIds.push(pidStr);
      }
    }
  }

  // 2. Fallback/Augment: Gather product IDs from DOM elements .cart__item[data-product-id]
  if (rawCartProductIds.length === 0) {
    var itemEls = document.querySelectorAll('#CartDrawer .cart__item[data-product-id], [data-products] .cart__item[data-product-id]');
    if (itemEls && itemEls.length > 0) {
      for (var j = 0; j < itemEls.length; j++) {
        var el = itemEls[j];
        var pidDom = el.getAttribute('data-product-id');
        if (pidDom) {
          var pidDomStr = String(pidDom).trim();
          if (pidDomStr) rawCartProductIds.push(pidDomStr);
        }
      }
    }
  }

  // Check if cart drawer explicitly has 'is-empty' class or 0 items
  var drawerEl = document.querySelector('#CartDrawer');
  var isDrawerEmpty = drawerEl && drawerEl.classList.contains('is-empty');

  // If cart is empty (0 products found or drawer marked empty):
  if (isDrawerEmpty || rawCartProductIds.length === 0) {
    // Return last 3 IDs from setting (or less if setting has 1 or 2)
    return takeLastMaxThree(settingIds);
  }

  // Cart has items! Filter unique product IDs preserving order of addition/appearance
  var uniqueCartPids = [];
  for (var k = 0; k < rawCartProductIds.length; k++) {
    var idVal = rawCartProductIds[k];
    if (uniqueCartPids.indexOf(idVal) === -1) {
      uniqueCartPids.push(idVal);
    }
  }

  // Take the last 3 items' product IDs from the cart
  return takeLastMaxThree(uniqueCartPids);
};

TagalysCustomisations.initProductBasedWidget = function (overrideProductIds, _isFallback) {
  var cfg = window.__AU_TAGALYS_CONFIG__ || {};
  var productIds = overrideProductIds;
  if (!productIds || !Array.isArray(productIds) || productIds.length === 0) {
    productIds = TagalysCustomisations.getProductIdsForRecommendations();
  }

  var currentIdsKey = productIds.join(',');

  /* Build the default/fallback product IDs from settings (same as empty cart) */
  var settingRaw = cfg.productIds || "9336888164660";
  var settingIds = String(settingRaw)
    .split(',')
    .map(function (id) { return id.trim(); })
    .filter(function (id) { return id.length > 0; });

  function takeLastMaxThree(arr) {
    if (!arr || arr.length === 0) return [];
    if (arr.length <= 3) return arr.slice();
    return arr.slice(arr.length - 3);
  }
  var fallbackIds = takeLastMaxThree(settingIds);
  var fallbackIdsKey = fallbackIds.join(',');

  /* Determine if current IDs are already the fallback (to avoid re-trying fallback on itself) */
  var isUsingFallbackIds = currentIdsKey === fallbackIdsKey;

  var opts = {
    recommendationId: cfg.recommendationId || "",
    productIds: productIds,
    callbacks: {},
    templates: {
      widget: {
        labels: {
          heading: cfg.heading || "You may also like",
        },
        options: {
          count: cfg.count || 16,
          displayFormat: "carousel",
          carouselOptions: {
            perPage: {
              300: 2,
              600: 2,
              900: 2,
              1200: 2,
              1440: 2,
              2560: 2,
            },
            duration: 200,
            easing: "ease-out",
            startIndex: 0,
            draggable: false,
          }
        },
      },
      loader: {
        render: function (html, args) {
          return html`
            <div class="loading-indicator"></div>
          `;
        }
      },
    }
  };

  var selectors = ['[data-pbw-loc="scrollable"]', '[data-pbw-loc="empty"]'];
  var count = 0;
  var initedEls = [];
  for (var i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    if (!el) continue;
    if (el.__auInited && el.__auLastProductIds === currentIdsKey && el.querySelectorAll('.product').length > 0) continue;
    if (el.__auInited) delete el.__auInited;
    try {
      Tagalys.UIWidgets.Recommendations.init(selectors[i], opts);
      el.__auInited = true;
      el.__auLastProductIds = currentIdsKey;
      initedEls.push(el);
      count++;
    } catch (e) {
      if (window.console) console.warn('[au-tagalys] Recommendations.init error for ' + selectors[i] + ':', e);
    }
  }

  /* ── Fallback: if not already a fallback call and not already using fallback IDs,
     schedule checks to see if Tagalys rendered any products. If not, re-init
     with the default/empty-cart product IDs so the user still sees recommendations. ── */
  if (count > 0 && !_isFallback && !isUsingFallbackIds && fallbackIds.length > 0) {
    var fallbackAttempted = false;

    function checkAndFallback() {
      if (fallbackAttempted) return;
      var hasProducts = false;
      for (var j = 0; j < initedEls.length; j++) {
        if (initedEls[j].querySelectorAll('.product').length > 0) {
          hasProducts = true;
          break;
        }
      }
      if (!hasProducts) {
        fallbackAttempted = true;
        if (window.console) console.info('[au-tagalys] No recommendations rendered for cart products, falling back to default IDs');
        /* Clear the inited state so the fallback re-init is accepted */
        for (var k = 0; k < initedEls.length; k++) {
          delete initedEls[k].__auInited;
          delete initedEls[k].__auLastProductIds;
          initedEls[k].innerHTML = '';
        }
        TagalysCustomisations.initProductBasedWidget(fallbackIds, true);
      }
    }

    /* Check at 3s and 5s — gives Tagalys enough time to fetch and render */
    setTimeout(checkAndFallback, 3000);
    setTimeout(checkAndFallback, 5000);
  }

  return count > 0;
};


/* ========================================================================
   Shared Utility Functions for Tagalys Recommendation & Recently Viewed
   ======================================================================== */

TagalysCustomisations.esc = function (str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

TagalysCustomisations.fixUrl = function (u) {
  if (!u) return '';
  if (u.indexOf('//') === 0) return 'https:' + u;
  return u;
};

TagalysCustomisations.formatPrice = function (val, currencySymbol) {
  if (!val && val !== 0) return '';
  if (typeof val === 'object' && val !== null) val = val.amount || 0;
  var s = String(val).trim();
  if (/[\u00a3$€A-Za-z]/.test(s)) return s;
  var num = parseFloat(s);
  if (isNaN(num)) return '';
  if (num > 999 && s.indexOf('.') === -1) num = num / 100;
  return currencySymbol + num.toFixed(2);
};

TagalysCustomisations.getNumericId = function (id) {
  if (!id) return '';
  var s = String(id);
  var parts = s.split('/');
  var last = parts[parts.length - 1];
  var match = last.match(/\d+/);
  return match ? match[0] : last;
};

TagalysCustomisations.getImageUrl = function (p) {
  if (p.image_url) return TagalysCustomisations.fixUrl(p.image_url);
  if (p.featured_image) return TagalysCustomisations.fixUrl(typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || p.featured_image.url || ''));
  if (p.featuredImage) return TagalysCustomisations.fixUrl(p.featuredImage.url || p.featuredImage.src || '');
  if (p.image) return TagalysCustomisations.fixUrl(typeof p.image === 'string' ? p.image : (p.image.src || p.image.url || ''));
  if (p.images && p.images.length > 0) {
    var img = p.images[0];
    return TagalysCustomisations.fixUrl(typeof img === 'string' ? img : (img.src || img.url || ''));
  }
  return '';
};

TagalysCustomisations.getTags = function (p) {
  if (!p.tags) return [];
  if (Array.isArray(p.tags)) return p.tags;
  if (typeof p.tags === 'string') return p.tags.split(',').map(function (t) { return t.trim(); });
  return [];
};

TagalysCustomisations.getBadgeHtml = function (p, onSale) {
  var tags = TagalysCustomisations.getTags(p);
  var available = p.available !== undefined ? !!p.available : (p.availableForSale !== undefined ? !!p.availableForSale : (p.in_stock !== undefined ? !!p.in_stock : (p.inventory !== undefined ? p.inventory > 0 : true)));

  if (p.metafields && p.metafields.theme && p.metafields.theme.label) {
    var val = p.metafields.theme.label.value || p.metafields.theme.label;
    if (val) {
      return '<div class="grid-product__tag grid-product__tag--custom">' + TagalysCustomisations.esc(val) + '</div>';
    }
  }

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];
    if (tag.indexOf('_label_') !== -1 && tag.charAt(0) === '_') {
      var label = tag.replace('_label_', '');
      return '<div class="grid-product__tag grid-product__tag--custom">' + TagalysCustomisations.esc(label) + '</div>';
    }
  }

  if (!available) {
    return '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>';
  }

  if (onSale) {
    return '<div class="grid-product__tag grid-product__tag--sale">SALE</div>';
  }

  return '';
};

TagalysCustomisations.getFirstVariantId = function (p) {
  if (p.first_available_variant && p.first_available_variant.id) return p.first_available_variant.id;
  if (p.variants && p.variants.length > 0) {
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return p.variants[i].id;
    }
    return p.variants[0].id;
  }
  if (p.default_variant && p.default_variant.id) return p.default_variant.id;
  if (p.variant_id) return p.variant_id;
  return null;
};

TagalysCustomisations.buildProductCard = function (p, opts) {
  if (!p) return '';
  opts = opts || {};

  var currencySymbol = opts.currencySymbol || '\u00a3';
  var btnText = opts.btnText || 'Add to Cart';
  var showReviews = opts.showReviews !== undefined ? !!opts.showReviews : true;
  var cssPrefix = opts.cssPrefix || 'au-rec';

  var title = p.name || p.title || '';
  var handle = p.handle || '';
  var url = p.link || p.url || p.onlineStoreUrl || '';
  if (!url && handle) url = '/products/' + handle;
  var rawId = p.__id || p.id || '';
  var numericId = TagalysCustomisations.getNumericId(rawId);

  var imageUrl = TagalysCustomisations.getImageUrl(p);
  var imageAlt = title;

  var price = p.sale_price || p.price || p.final_price || 0;
  var compareAt = p.regular_price || p.compare_at_price || p.compareAtPrice || p.original_price || p.compare_at_price_max || 0;
  if (typeof price === 'object' && price !== null) price = price.amount || 0;
  if (typeof compareAt === 'object' && compareAt !== null) compareAt = compareAt.amount || 0;
  var priceNum = parseFloat(price) || 0;
  var compareNum = parseFloat(compareAt) || 0;
  var onSale = compareNum > priceNum && compareNum > 0;

  var variantId = TagalysCustomisations.getFirstVariantId(p);

  var imageHtml = '';
  if (p.is_placeholder && p.placeholder_svg) {
    imageHtml =
      '<div class="image-wrap" style="height:0;padding-bottom:100%;position:relative;overflow:hidden;background:#f5f5f5;">' +
      p.placeholder_svg +
      '</div>';
  } else if (imageUrl) {
    imageHtml =
      '<div class="image-wrap" style="height:0;padding-bottom:100%;position:relative;overflow:hidden;">' +
      '<img class="grid-product__image lazyloaded" ' +
      'src="' + TagalysCustomisations.esc(imageUrl) + '" ' +
      'alt="' + TagalysCustomisations.esc(imageAlt) + '" ' +
      'loading="lazy" ' +
      'style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;opacity:1!important;">' +
      '</div>';
  } else {
    imageHtml = '<div class="image-wrap" style="height:0;padding-bottom:100%;background:#f5f5f5;"></div>';
  }

  var badgeHtml = TagalysCustomisations.getBadgeHtml(p, onSale);

  var savingsHtml = '';
  if (onSale) {
    var isBundle = false;
    var tags = TagalysCustomisations.getTags(p);
    for (var t = 0; t < tags.length; t++) {
      if (tags[t].toLowerCase() === 'bundles' || tags[t].toLowerCase() === 'biscuits-bundle') {
        isBundle = true;
        break;
      }
    }
    if (!isBundle && p.type) {
      isBundle = p.type.toLowerCase().indexOf('bundles') !== -1;
    }
    var savedAmount = '';
    if (isBundle) {
      savedAmount = TagalysCustomisations.formatPrice(compareNum - priceNum, currencySymbol);
    } else {
      savedAmount = Math.round((compareNum - priceNum) * 100.0 / compareNum) + '%';
    }
    savingsHtml = '<span class="grid-product__price--savings">SAVE ' + savedAmount + '</span>';
  }

  var priceHtml = '';
  if (onSale) {
    priceHtml +=
      '<span class="visually-hidden">Regular price</span>' +
      '<span class="grid-product__price--original">' + TagalysCustomisations.formatPrice(compareAt, currencySymbol) + '</span>' +
      '<span class="visually-hidden">Sale price</span> ';
  }
  priceHtml += '<span class="price-min-current">' + TagalysCustomisations.formatPrice(price, currencySymbol) + '</span>';
  if (savingsHtml) priceHtml += savingsHtml;

  var available = p.available !== undefined ? !!p.available : (p.availableForSale !== undefined ? !!p.availableForSale : (p.in_stock !== undefined ? !!p.in_stock : (p.inventory !== undefined ? p.inventory > 0 : true)));
  var finalBtnText = available ? btnText : 'Sold Out';
  var disabledAttr = available ? '' : ' disabled="disabled"';

  var starsHtml = showReviews
    ? '<div data-oke-star-rating data-oke-reviews-product-id="shopify-' + TagalysCustomisations.esc(numericId) + '" class="grid-product__star-rating"></div>'
    : '';

  return '<div class="' + cssPrefix + '__card" data-product-handle="' + TagalysCustomisations.esc(handle) + '" data-product-id="shopify-' + TagalysCustomisations.esc(numericId) + '">' +
    '<div class="grid-product__content">' +
    '<div class="' + cssPrefix + '__badge-container" style="opacity: 0; transition: opacity 0.2s ease;">' + badgeHtml + '</div>' +
    '<a href="' + TagalysCustomisations.esc(url) + '" class="grid-product__link">' +
    '<div class="grid-product__image-mask">' + imageHtml + '</div>' +
    '<div class="grid-product__meta">' +
    starsHtml +
    '<div class="grid-product__title grid-product__title--body">' + TagalysCustomisations.esc(title) + '</div>' +
    '<div class="grid-product__price">' + priceHtml + '</div>' +
    '</div>' +
    '</a>' +
    '<button class="' + cssPrefix + '__atc-btn" data-au-action="add" data-variant-id="' + (variantId || '') + '" data-handle="' + TagalysCustomisations.esc(handle) + '" data-url="' + TagalysCustomisations.esc(url) + '"' + disabledAttr + '>' + finalBtnText + '</button>' +
    '</div>' +
    '</div>';
};

TagalysCustomisations.loadOkendoStars = function (container) {
  var retries = 0;
  var maxRetries = 20;

  function tryInit() {
    var stars = container.querySelectorAll('[data-oke-star-rating]');
    var apiReady = window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function';

    if (apiReady) {
      for (var i = 0; i < stars.length; i++) {
        var el = stars[i];
        if (!el.__okeInited) {
          try {
            window.okeWidgetApi.initWidget(el, true);
            el.__okeInited = true;
          } catch (e) {
          }
        }
      }
    }

    if (window.oke && typeof window.oke.init === 'function') {
      try { window.oke.init(); } catch (e) { }
    }
    if (window.okeReviewsWidgetAPI && typeof window.okeReviewsWidgetAPI.init === 'function') {
      try { window.okeReviewsWidgetAPI.init(); } catch (e) { }
    }
    try { document.dispatchEvent(new CustomEvent('oke:init')); } catch (e) { }
    try { document.dispatchEvent(new CustomEvent('oke-widgets-loaded')); } catch (e) { }

    retries++;
    if (retries < maxRetries) {
      setTimeout(tryInit, 500);
    }
  }

  tryInit();
};

TagalysCustomisations.updateCtaLabels = function (container, cssPrefix) {
  cssPrefix = cssPrefix || 'au-rec';
  var btnSelector = '.' + cssPrefix + '__atc-btn[data-handle]';
  var buttons = container.querySelectorAll(btnSelector);
  var handles = [];
  var seen = {};
  for (var i = 0; i < buttons.length; i++) {
    var h = buttons[i].getAttribute('data-handle');
    if (h && !seen[h]) {
      seen[h] = true;
      handles.push(h);
    }
  }

  handles.forEach(function (handle) {
    fetch('/products/' + handle + '?sections=cta-label-api')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cta-label-api'] || '';

        var match = html.match(/data-cta-label="([^"]*)"/);
        var label = match ? match[1] : '';
        if (label) {
          var trimmed = label.trim();
          var lower = trimmed.toLowerCase();
          if (lower !== '' && lower !== 'none') {
            var displayText = trimmed;
            if (lower.indexOf('add to cart') === -1) {
              var words = trimmed.split(/\s+/);
              if (words.length > 2) {
                displayText = words.slice(0, 2).join(' ');
              }
            }

            var isAtc = lower.indexOf('add to cart') !== -1;
            var btns = container.querySelectorAll('.' + cssPrefix + '__atc-btn[data-handle="' + handle + '"]:not([disabled])');
            for (var j = 0; j < btns.length; j++) {
              btns[j].textContent = displayText;
              if (!isAtc) {
                btns[j].setAttribute('data-au-action', 'navigate');
              }
            }
          }
        }

        var badgeHtmlMatch = html.match(/<div id="cta-label-data"[^>]*>([\s\S]*?)<\/div>/);
        var serverBadgeHtml = badgeHtmlMatch ? badgeHtmlMatch[1].trim() : '';
        var badgeContainers = container.querySelectorAll('.' + cssPrefix + '__card[data-product-handle="' + handle + '"] .' + cssPrefix + '__badge-container');
        for (var k = 0; k < badgeContainers.length; k++) {
          badgeContainers[k].innerHTML = serverBadgeHtml;
          badgeContainers[k].style.opacity = '1';
        }

        var savingsMatch = html.match(/data-savings-label="([^"]*)"/);
        var savingsLabel = savingsMatch ? savingsMatch[1].trim() : '';
        var savingsEls = container.querySelectorAll('.' + cssPrefix + '__card[data-product-handle="' + handle + '"] .grid-product__price--savings');
        for (var s = 0; s < savingsEls.length; s++) {
          if (savingsLabel) {
            savingsEls[s].textContent = savingsLabel;
          } else {
            savingsEls[s].style.display = 'none';
          }
        }

        var fromMatch = html.match(/data-show-from="([^"]*)"/);
        var showFrom = fromMatch ? fromMatch[1].trim() === 'true' : false;
        if (showFrom) {
          var priceContainers = container.querySelectorAll('.' + cssPrefix + '__card[data-product-handle="' + handle + '"] .grid-product__price');
          for (var f = 0; f < priceContainers.length; f++) {
            var priceEl = priceContainers[f];
            if (!priceEl.querySelector('.from-text')) {
              var fromSpan = document.createElement('span');
              fromSpan.className = 'non-strikethrough from-text';
              fromSpan.textContent = 'from';
              var strikeEl = priceEl.querySelector('.grid-product__price--original');
              if (strikeEl && strikeEl.nextSibling) {
                priceEl.insertBefore(fromSpan, strikeEl.nextSibling);
              } else {
                priceEl.insertBefore(fromSpan, priceEl.firstChild);
              }
            }
          }
        }
      })
      .catch(function (err) {
      });
  });
};

TagalysCustomisations.performAddToCart = function (btn, variantId, opts) {
  opts = opts || {};
  var btnText = opts.btnText || 'Add to Cart';
  var addedClass = opts.addedClass || 'au-rec__atc--added';
  var useDataAction = opts.useDataAction !== undefined ? !!opts.useDataAction : true;

  btn.textContent = 'Adding...';
  btn.disabled = true;

  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = function () {
    if (xhr.status === 200) {
      btn.textContent = 'Added';
      if (useDataAction) {
        btn.setAttribute('data-au-action', 'navigate');
      }
      btn.classList.add(addedClass);

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { addToCartBtn: btn } }));

      setTimeout(function () {
        btn.textContent = btnText;
        btn.disabled = false;
        btn.classList.remove(addedClass);
        if (useDataAction) {
          btn.setAttribute('data-au-action', 'add');
        }
      }, 2000);
    } else {
      btn.textContent = btnText;
      btn.disabled = false;
    }
  };
  xhr.onerror = function () {
    btn.textContent = btnText;
    btn.disabled = false;
  };
  xhr.send(JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }));
};

TagalysCustomisations.handleAtcClick = function (btn, opts) {
  opts = opts || {};
  var btnText = opts.btnText || 'Add to Cart';
  var addedClass = opts.addedClass || 'au-rec__atc--added';
  var useDataAction = opts.useDataAction !== undefined ? !!opts.useDataAction : true;

  var variantId = btn.getAttribute('data-variant-id');
  var handle = btn.getAttribute('data-handle');
  var url = btn.getAttribute('data-url');
  var action = btn.getAttribute('data-au-action');

  if (useDataAction) {
    if (action === 'add') {
      if (variantId) {
        TagalysCustomisations.performAddToCart(btn, variantId, { btnText: btnText, addedClass: addedClass, useDataAction: useDataAction });
      } else if (handle) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/products/' + handle + '.js');
        xhr.onload = function () {
          if (xhr.status === 200) {
            var product = JSON.parse(xhr.responseText);
            var vId = null;
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].available) {
                vId = product.variants[i].id;
                break;
              }
            }
            if (vId) {
              btn.setAttribute('data-variant-id', vId);
              TagalysCustomisations.performAddToCart(btn, vId, { btnText: btnText, addedClass: addedClass, useDataAction: useDataAction });
            } else {
              btn.textContent = btnText;
              btn.disabled = false;
            }
          } else {
            btn.textContent = btnText;
            btn.disabled = false;
          }
        };
        xhr.onerror = function () {
          btn.textContent = btnText;
          btn.disabled = false;
        };
        xhr.send();
      }
    } else {
      if (url) {
        window.location.href = url;
      } else if (handle) {
        window.location.href = '/products/' + handle;
      }
    }
  } else {
    /* Legacy mode: detect by button text */
    var currentText = (btn.textContent || '').trim().toLowerCase();
    if (currentText.indexOf('add to cart') !== -1) {
      if (variantId) {
        TagalysCustomisations.performAddToCart(btn, variantId, { btnText: btnText, addedClass: addedClass, useDataAction: useDataAction });
      } else if (handle) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/products/' + handle + '.js');
        xhr.onload = function () {
          if (xhr.status === 200) {
            var product = JSON.parse(xhr.responseText);
            var vId = null;
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i].available) {
                vId = product.variants[i].id;
                break;
              }
            }
            if (vId) {
              btn.setAttribute('data-variant-id', vId);
              TagalysCustomisations.performAddToCart(btn, vId, { btnText: btnText, addedClass: addedClass, useDataAction: useDataAction });
            } else {
              btn.textContent = btnText;
              btn.disabled = false;
            }
          } else {
            btn.textContent = btnText;
            btn.disabled = false;
          }
        };
        xhr.onerror = function () {
          btn.textContent = btnText;
          btn.disabled = false;
        };
        xhr.send();
      }
    } else {
      if (url) {
        window.location.href = url;
      } else if (handle) {
        window.location.href = '/products/' + handle;
      }
    }
  }
};